export default "__VITE_ASSET__C55UpAon__"